export const EMPLOYEE_DETAIL_FETCH = 'EMPLOYEE_DETAIL_FETCH';
export const EMPLOYEE_DETAIL_SUCCESS = 'EMPLOYEE_DETAIL_SUCCESS';
export const EMPLOYEE_DETAIL_FAILURE = 'EMPLOYEE_DETAIL_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/EmployeeDetail/actionTypes.js